import Layout from 'components/Layout';
import withGuard from 'components/withGuard';
import { PERMISSIONS } from 'constants/permissions';
import React from 'react';
import { useSearchParams } from 'react-router';
import OrderForm from './Form';
import Steps from './Steps';

function CreateOrder() {
  const [searchParams] = useSearchParams();
  const isClone = Boolean(searchParams.get('clone'));

  return (
    <Layout header={(
      <Layout.Header
        title={isClone ? 'Copy Order' : 'New Order'}
        backTitle="Orders"
        backPath="/console/orders"
      />
    )}
    >
      <Steps>
        <OrderForm />
      </Steps>
    </Layout>
  );
}
export default withGuard(CreateOrder, [PERMISSIONS.ORDERS], { redirect: true });
